import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Lottie from "lottie-react";
import * as codingBoy from "../../../assets/404/notFound.json";
const NotFound = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <section>
      <Sidebar></Sidebar>

      {loading ? (
        <LoadingSpinner></LoadingSpinner>
      ) : (
        <div className="lg:pl-[220px]">
          <div className="w-full">
            <div className="flex flex-col w-full min-h-screen items-center justify-center space-y-8">
              <Lottie
                animationData={codingBoy}
                loop={true}
                className="w-[50%] lg:w-[30%]"
              />
              <div>
                <h2 className="para-text text-dark-blue-xxl dark:text-white text-2xl lg:text-4xl font-bold">
                  <span className="text-dark-blue-xxl dark:text-primary">Page</span> Not Found !
                </h2>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default NotFound;
